import React, { useState } from 'react';
import { Box, Card, CardHeader, CardBody, Heading, Text, Button, Flex, Icon, Badge, useToast, Divider, Textarea } from '@chakra-ui/react';
import { FiAlertCircle, FiCheck, FiX, FiEdit2 } from 'react-icons/fi';
import FqClaimDetailShell from './FqClaimDetailShell';

const mockData = {
  type: 'Pre-Submission',
  patient: { first_name: 'James', last_name: 'Wilson', member_id: 'MC112233445' },
  provider: { name: 'Dr. Robert Chen', npi: '2109876543' },
  claim: {
    diagnoses: ['S61.212A'], // Laceration without foreign body of left index finger
    procedures: [
      { cpt: '12001', modifiers: [], charge: 200.00 }, // Simple repair superficial wounds
      { cpt: 'T1015', modifiers: [], charge: 0.00 } // Clinic visit
    ],
    clinical_note: "Patient returned to clinic at 4:30 PM after sustaining a deep laceration to the left index finger while chopping vegetables at home. Patient was seen earlier today at 9:00 AM for a routine hypertension follow-up. Wound cleaned and closed with 4 sutures. Tolerated procedure well."
  }
};

const FqDemoBox80 = () => {
  const [isApproved, setIsApproved] = useState(false);
  const [box80Text, setBox80Text] = useState("Patient seen earlier today for routine HTN follow-up. Returned later same day with new acute injury (laceration to left index finger requiring sutures). Second visit justified per CA Medi-Cal guidelines.");
  const toast = useToast();

  const handleApprove = () => {
    setIsApproved(true);
    toast({
      title: "Box 80 Appended",
      description: "Justification added to claim. Claim cleared for submission.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  const rightPanel = (
    <Card borderColor="purple.200" borderWidth="2px" shadow="md">
      <CardHeader bg="purple.50" pb={4}>
        <Flex justify="space-between" align="center">
          <Heading size="md" display="flex" alignItems="center" color="purple.800">
            <Icon as={FiAlertCircle} mr={2} />
            Revedy Action Required
          </Heading>
          <Badge colorScheme="purple" variant="solid">Tier B</Badge>
        </Flex>
      </CardHeader>
      <CardBody>
        <Box mb={4}>
          <Text fontWeight="bold" color="orange.600" mb={1}>Scrub Error (Same-Day Visit):</Text>
          <Text fontSize="sm">A PPS encounter (T1015) has already been billed for this patient on this date of service.</Text>
        </Box>
        
        <Divider my={4} />

        <Box mb={4}>
          <Text fontWeight="bold" color="purple.700" mb={1}>Revedy Analysis:</Text>
          <Text fontSize="sm" mb={2}>
            The clinical note confirms this is a legitimate second visit for a new illness/injury that occurred after the first visit. CA Medi-Cal allows a second PPS payment in this scenario if justified in Box 80.
          </Text>
        </Box>

        <Box mb={4} p={3} bg="gray.50" borderRadius="md" borderLeft="4px solid" borderLeftColor="purple.400">
          <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" mb={1}>Rule Citation:</Text>
          <Text fontSize="sm" fontStyle="italic">"A second encounter is reimbursable when the patient suffers an illness or injury subsequent to the first encounter that requires additional diagnosis or treatment." (DHCS FQHC/RHC Manual)</Text>
        </Box>

        <Box mb={6}>
          <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" mb={1}>Proposed Box 80 Remarks:</Text>
          <Textarea 
            value={box80Text}
            onChange={(e) => setBox80Text(e.target.value)}
            size="sm"
            rows={4}
            isDisabled={isApproved}
          />
        </Box>

        <Flex gap={3}>
          <Button 
            flex="1" 
            colorScheme="purple" 
            leftIcon={<FiCheck />} 
            onClick={handleApprove}
            isDisabled={isApproved}
          >
            {isApproved ? 'Approved' : 'Approve & Append'}
          </Button>
          <Button variant="ghost" colorScheme="red" isDisabled={isApproved}>
            <Icon as={FiX} />
          </Button>
        </Flex>
      </CardBody>
    </Card>
  );

  return <FqClaimDetailShell claimData={mockData} rightPanel={rightPanel} backTo="/fq/pre-submission" />;
};

export default FqDemoBox80;